/**
 * H5 首页等页面：路由 hash 与 document 锚点滚动（与 MobileNav 内链共用）
 */

/**
 * 将 Vue Router 的 hash（含 #）解析为 getElementById 可用的 id
 * @param {string} raw 如 "#section-news"
 * @returns {string|null}
 */
export function decodeRouteHashAnchorId(raw) {
  if (!raw || raw === "#") return null;
  let id;
  try {
    id = decodeURIComponent(raw.slice(1));
  } catch {
    id = raw.slice(1);
  }
  return id || null;
}

/**
 * 按 id 平滑滚动到对应元素
 * @param {string} anchorId
 * @param {ScrollIntoViewOptions} [options]
 * @returns {boolean} 是否找到元素并已触发滚动
 */
export function scrollToAnchorById(
  anchorId,
  options = { behavior: "smooth", block: "start" }
) {
  if (!anchorId) return false;
  const el = document.getElementById(anchorId);
  if (!el) return false;
  el.scrollIntoView(options);
  return true;
}

/**
 * 程序化滚动结束后回调（优先 scrollend，否则超时兜底）
 * @param {() => void} onDone
 * @param {{ timeoutMs?: number }} [opts]
 */
export function afterScrollSettled(onDone, opts = {}) {
  const { timeoutMs = 900 } = opts;
  let finished = false;
  const done = () => {
    if (finished) return;
    finished = true;
    onDone();
  };
  if (typeof window !== "undefined" && "onscrollend" in window) {
    window.addEventListener("scrollend", done, { once: true });
  }
  setTimeout(done, timeoutMs);
}
